module.exports = __webpack_public_path__ + "img/Romantikk_Nasjonalromantikken.e729e794.jpg";